<template>
  <section v-show="isBoxVisible">
    <h4 class="fs-20 font-medium mb-4">
      Traveler rating
    </h4>

    <checkbox v-model="options.ratingOptions.excellent"
      v-show="isRatingVisible([5])"
      @change="$emit('filter-changed')">
      Excellent
    </checkbox>
    <checkbox v-model="options.ratingOptions.very_good"
      v-show="isRatingVisible([4])"
      @change="$emit('filter-changed')">
      Very Good
    </checkbox>
    <checkbox v-model="options.ratingOptions.average"
      v-show="isRatingVisible([3])"
      @change="$emit('filter-changed')">
      Average
    </checkbox>
    <checkbox v-model="options.ratingOptions.poor"
      v-show="isRatingVisible([2, 1])"
      @change="$emit('filter-changed')">
      Poor
    </checkbox>
    <checkbox v-model="options.ratingOptions.unrated"
      v-show="isRatingVisible([0])"
      @change="$emit('filter-changed')">
      Unrated
    </checkbox>
  </section>
</template>

<script>
import get from 'lodash/get'
import { mapState } from 'vuex'
import Checkbox from '../../core/Checkbox'

export default {
  components: {
    Checkbox
  },
  inject: ['options'],
  computed: {
    ...mapState(['statistics']),
    isBoxVisible () {
      return this.isRatingVisible([1,2,3,4,5])
    }
  },
  methods: {
    isRatingVisible (ratings) {
      return ratings.some(rating => {
        return get(this.statistics, ['visibleRatings', rating], false) === true
      })
    }
  }
}
</script>